import {useContextProps as $64fa3d84918910a7$export$29f1550f4b0d4415} from "./utils.mjs";
import {SharedElement as $c8a5a149f625efcf$export$c34620ff8881d89f} from "./SharedElementTransition.mjs";
import $4GgyL$react, {createContext as $4GgyL$createContext, forwardRef as $4GgyL$forwardRef} from "react";

/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


const $1d5b8b8664671ef2$export$c9549807523555e0 = /*#__PURE__*/ (0, $4GgyL$createContext)({
    isSelected: false
});
const $1d5b8b8664671ef2$export$17f80983afe4e444 = /*#__PURE__*/ (0, $4GgyL$forwardRef)(function SelectionIndicator(props, ref) {
    [props, ref] = (0, $64fa3d84918910a7$export$29f1550f4b0d4415)(props, ref, $1d5b8b8664671ef2$export$c9549807523555e0);
    let { isSelected: isSelected, ...otherProps } = props;
    return /*#__PURE__*/ (0, $4GgyL$react).createElement((0, $c8a5a149f625efcf$export$c34620ff8881d89f), {
        ...otherProps,
        ref: ref,
        className: props.className || 'react-aria-SelectionIndicator',
        name: "SelectionIndicator",
        isVisible: isSelected
    });
});


export {$1d5b8b8664671ef2$export$c9549807523555e0 as SelectionIndicatorContext, $1d5b8b8664671ef2$export$17f80983afe4e444 as SelectionIndicator};
//# sourceMappingURL=SelectionIndicator.module.js.map
